import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Badge, Spinner, Modal, Pagination, Tabs, Tab, Alert } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DataKamar = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [username, setUsername] = useState('Administrator');
  // eslint-disable-next-line no-unused-vars
  const [menus, setMenus] = useState([]);
  const [time, setTime] = useState({ date: '', clock: '' });
  const [systemAlert, setSystemAlert] = useState(null);

  // Data Kamar State
  const [kamarList, setKamarList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedKelasFilter, setSelectedKelasFilter] = useState('');
  const [selectedGedungFilter, setSelectedGedungFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Kamar Aplicares BPJS State
  const [kamarBpjsList, setKamarBpjsList] = useState([]);
  const [isLoadingBpjs, setIsLoadingBpjs] = useState(false);

  // Referensi Kelas BPJS State
  const [refKelasBpjsList, setRefKelasBpjsList] = useState([]);
  const [isLoadingRefKelas, setIsLoadingRefKelas] = useState(false);

  // Data Kelas RS State
  const [kelasRsList, setKelasRsList] = useState([]);
  const [isLoadingKelasRs, setIsLoadingKelasRs] = useState(false);
  const [currentPageKelasRs, setCurrentPageKelasRs] = useState(1);

  // Tarif Kamar Rawat State
  const [tarifKamarList, setTarifKamarList] = useState([]);
  const [isLoadingTarifKamar, setIsLoadingTarifKamar] = useState(false);
  const [searchTarifKamar, setSearchTarifKamar] = useState('');
  const [currentPageTarifKamar, setCurrentPageTarifKamar] = useState(1);
  const [itemsPerPageTarifKamar, setItemsPerPageTarifKamar] = useState(10);
  const [klasifikasiList, setKlasifikasiList] = useState([]);
  const [selectedKdKlasifikasi, setSelectedKdKlasifikasi] = useState('');
  const [isLoadingKlasifikasi, setIsLoadingKlasifikasi] = useState(false);

  // Divisi Options State for Form
  const [divisiOptions, setDivisiOptions] = useState([]);

  // Form State untuk Input/Edit
  const [formKodeKamar, setFormKodeKamar] = useState('');
  const [formNamaKamar, setFormNamaKamar] = useState('');
  const [formKelas, setFormKelas] = useState('Kelas 1');
  const [formGedung, setFormGedung] = useState('Gedung B');
  const [formLantai, setFormLantai] = useState('Satu');
  const [formKapasitas, setFormKapasitas] = useState(2);
  const [formKodeDivisi, setFormKodeDivisi] = useState('-');
  const [formNamaDivisi, setFormNamaDivisi] = useState('-');
  const [formSatuSehatId, setFormSatuSehatId] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);

  // State untuk Hapus Kamar BPJS Aplicares
  const [showDeleteBpjsModal, setShowDeleteBpjsModal] = useState(false);
  const [formKodeKelasBpjs, setFormKodeKelasBpjs] = useState('');
  const [formKodeRuangBpjs, setFormKodeRuangBpjs] = useState('');
  const [formTypeTrxBpjs, setFormTypeTrxBpjs] = useState('HAPUS');
  const [isDeletingBpjs, setIsDeletingBpjs] = useState(false);

  // Fallback Mock Data matching requested response JSON
  const mockKamar = [
    {
      "kapasitas": 0,
      "kd_gedung": "02",
      "kd_kamar": "001",
      "kd_lantai": "01",
      "nm_gedung": "Gedung B",
      "nm_kamar": "UGD",
      "nm_kelas": "Poliklinik dan UGD",
      "nm_lantai": "Satu",
      "satusehat_id": null
    },
    {
      "kapasitas": 2,
      "kd_gedung": "02",
      "kd_kamar": "002",
      "kd_lantai": "02",
      "nm_gedung": "Gedung B",
      "nm_kamar": "2001",
      "nm_kelas": "Kelas 1",
      "nm_lantai": "Dua",
      "satusehat_id": "d358f7a4-0679-453b-9bf9-060d6a5a1549"
    }
  ];

  // Fetch data kamar dari backend /show_kamar
  const fetchKamar = async () => {
    setIsLoading(true);
    setFetchError('');
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/show_kamar`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json = await response.json();
      if (json && json.list_kamar) {
        setKamarList(json.list_kamar);
      } else {
        setKamarList(mockKamar);
      }
    } catch (err) {
      console.warn("Gagal terhubung ke backend /show_kamar, menggunakan data lokal:", err);
      setKamarList(mockKamar);
      setFetchError("Menggunakan data lokal. Gagal terhubung ke server backend.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchKamarBpjs = async () => {
    setIsLoadingBpjs(true);
    try {
      const apiUrl = getApiUrl();
      const res = await fetch(`${apiUrl}/readkamarbpjs`);
      if (res.ok) {
        const json = await res.json();
        if (json?.response?.response?.list) {
          setKamarBpjsList(json.response.response.list);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /readkamarbpjs:", err);
    } finally {
      setIsLoadingBpjs(false);
    }
  };

  const fetchRefKelasBpjs = async () => {
    setIsLoadingRefKelas(true);
    try {
      const apiUrl = getApiUrl();
      const res = await fetch(`${apiUrl}/refkelasbpjs`);
      if (res.ok) {
        const json = await res.json();
        if (json?.response?.response?.list) {
          setRefKelasBpjsList(json.response.response.list);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /refkelasbpjs:", err);
    } finally {
      setIsLoadingRefKelas(false);
    }
  };

  const fetchKelasRs = async () => {
    setIsLoadingKelasRs(true);
    try {
      const apiUrl = getApiUrl();
      const res = await fetch(`${apiUrl}/show_kelas`);
      if (res.ok) {
        const json = await res.json();
        if (json?.list_kelas) {
          setKelasRsList(json.list_kelas);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /show_kelas:", err);
    } finally {
      setIsLoadingKelasRs(false);
    }
  };

  // Fetch Divisi Options
  const fetchDivisiOptions = async () => {
    try {
      const res = await fetch(`${getApiUrl()}/show_divisi`);
      if (res.ok) {
        const json = await res.json();
        if (json?.list_divisi) {
          setDivisiOptions(json.list_divisi);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /show_divisi:", err);
    }
  };

  // Fetch Klasifikasi Tarif
  const fetchKlasifikasi = async () => {
    setIsLoadingKlasifikasi(true);
    try {
      const apiUrl = getApiUrl();
      const res = await fetch(`${apiUrl}/show_klasifikasi`);
      if (res.ok) {
        const json = await res.json();
        if (json?.list_klasifikasi && Array.isArray(json.list_klasifikasi)) {
          setKlasifikasiList(json.list_klasifikasi);
        } else if (Array.isArray(json)) {
          setKlasifikasiList(json);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /show_klasifikasi:", err);
    } finally {
      setIsLoadingKlasifikasi(false);
    }
  };

  // Fetch Tarif Kamar Rawat
  const fetchTarifKamar = async (kdKlas = selectedKdKlasifikasi) => {
    setIsLoadingTarifKamar(true);
    try {
      const apiUrl = getApiUrl();
      const endpoint = kdKlas
        ? `${apiUrl}/show_tarifkamar?kd_klasifikasi=${encodeURIComponent(kdKlas)}`
        : `${apiUrl}/show_tarifkamar`;
      const res = await fetch(endpoint);
      if (res.ok) {
        const json = await res.json();
        if (json?.list_tarifkamar) {
          setTarifKamarList(json.list_tarifkamar);
        }
      }
    } catch (err) {
      console.warn("Gagal terhubung ke endpoint /show_tarifkamar:", err);
    } finally {
      setIsLoadingTarifKamar(false);
    }
  };

  useEffect(() => {
    // Info User & Menu
    const savedUser = localStorage.getItem('nama_user') || localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      setMenus(JSON.parse(savedMenu));
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);

    fetchKamar();
    fetchKamarBpjs();
    fetchRefKelasBpjs();
    fetchKelasRs();
    fetchTarifKamar();
    fetchDivisiOptions();
    fetchKlasifikasi();

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ambil list unik kelas & gedung untuk dropdown filter
  const uniqueKelas = [...new Set(kamarList.map(k => k.nm_kelas))].filter(Boolean);
  const uniqueGedung = [...new Set(kamarList.map(k => k.nm_gedung))].filter(Boolean);

  // Rangkuman Total Kamar & Bed masing-masing Kelas
  const classSummary = uniqueKelas.map(kelasName => {
    const roomsInClass = kamarList.filter(k => k.nm_kelas === kelasName);
    const totalBedsInClass = roomsInClass.reduce((acc, k) => acc + (Number(k.kapasitas) || 0), 0);
    return {
      kelas: kelasName || 'Non-Kelas',
      totalKamar: roomsInClass.length,
      totalBed: totalBedsInClass
    };
  });

  const grandTotalBeds = kamarList.reduce((acc, k) => acc + (Number(k.kapasitas) || 0), 0);

  // Filter List Kamar
  const filteredKamar = kamarList.filter(item => {
    const matchesSearch = 
      (item.nm_kamar && item.nm_kamar.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.kd_kamar && item.kd_kamar.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.nm_kelas && item.nm_kelas.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.nm_gedung && item.nm_gedung.toLowerCase().includes(searchQuery.toLowerCase()));
    
    const matchesKelas = selectedKelasFilter ? item.nm_kelas === selectedKelasFilter : true;
    const matchesGedung = selectedGedungFilter ? item.nm_gedung === selectedGedungFilter : true;

    return matchesSearch && matchesKelas && matchesGedung;
  });

  // Paginated List
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredKamar.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredKamar.length / itemsPerPage);

  // Pilih Kamar untuk di-edit
  const handleSelectEdit = (item) => {
    setFormKodeKamar(item.kd_kamar || '');
    setFormNamaKamar(item.nm_kamar || '');
    setFormKelas(item.nm_kelas || 'Kelas 1');
    setFormGedung(item.nm_gedung || 'Gedung B');
    setFormLantai(item.nm_lantai || 'Satu');
    setFormKodeDivisi(item.kd_divisi || '-');
    setFormNamaDivisi(item.nm_divisi || '-');
    setFormKapasitas(item.kapasitas ?? 2);
    setFormSatuSehatId(item.satusehat_id || '');
    setIsEditing(true);
    setShowFormModal(true);
  };

  // Bersihkan form
  const handleClearForm = () => {
    setFormKodeKamar('');
    setFormNamaKamar('');
    setFormKelas('Kelas 1');
    setFormGedung('Gedung B');
    setFormLantai('Satu');
    setFormKodeDivisi('-');
    setFormNamaDivisi('-');
    setFormKapasitas(2);
    setFormSatuSehatId('');
    setIsEditing(false);
    setShowFormModal(false);
  };

  // Submit Simpan (Hubungkan ke endpoint backend)
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Mapping kode kelas dasar
    let mappedKdKelas = "-";
    if (formKelas === 'Kelas 1') mappedKdKelas = "002";
    else if (formKelas === 'Kelas 2') mappedKdKelas = "003";
    else if (formKelas === 'Kelas 3') mappedKdKelas = "005";
    else if (formKelas === 'Kelas VIP') mappedKdKelas = "006";
    else if (formKelas === 'Kelas ICU') mappedKdKelas = "008";
    else if (formKelas === 'Kelas Isolasi') mappedKdKelas = "009";
    else if (formKelas === 'Poliklinik dan UGD') mappedKdKelas = "001";

    const payload = {
      kd_kamar: formKodeKamar || `KAM-${Math.floor(Math.random() * 1000)}`,
      nm_kamar: formNamaKamar,
      kd_divisi: formKodeDivisi,
      nm_divisi: formNamaDivisi,
      total_val: parseInt(formKapasitas, 10) || 0,
      kapasitas: parseInt(formKapasitas, 10) || 0,
      kd_kelas: mappedKdKelas,
      nm_kelas: formKelas,
      kd_gedung: formGedung === 'Gedung B' ? '02' : '01',
      nm_gedung: formGedung,
      kd_lantai: formLantai === 'Dua' ? '02' : '01',
      nm_lantai: formLantai,
      kd_subdivisi: "-",
      nm_subdivisi: "-",
      jns: "-",
      keterangan: "-"
    };

    try {
      const apiUrl = getApiUrl();
      const response = await fetch(`${apiUrl}/simpan_data_kamar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        setSystemAlert({ variant: 'success', message: 'Data ruangan berhasil disimpan!' });
        setTimeout(() => setSystemAlert(null), 3000);
        fetchKamar(); // Reload data dari backend
        handleClearForm();
      } else {
        setSystemAlert({ variant: 'danger', message: 'Gagal menyimpan data ruangan (Error dari server).' });
        setTimeout(() => setSystemAlert(null), 3000);
      }
    } catch (error) {
      console.error("Gagal menyimpan data kamar:", error);
      setSystemAlert({ variant: 'danger', message: 'Terjadi kesalahan jaringan saat menyimpan data kamar.' });
      setTimeout(() => setSystemAlert(null), 3000);
    }
  };

  // Hapus Data Kamar (Lokal)
  const handleDelete = (kdKamar) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data kamar ini?")) {
      setKamarList(prev => prev.filter(k => k.kd_kamar !== kdKamar));
    }
  };

  // Buka Modal Update Kamar BPJS
  const handleOpenUpdateBpjs = (item) => {
    setFormKodeKelasBpjs(item.kodekelas || '');
    setFormKodeRuangBpjs(item.koderuang || '');
    setFormTypeTrxBpjs('INPUT');
    setShowDeleteBpjsModal(true);
  };

  // Buka Modal Create Kamar BPJS Baru
  const handleOpenCreateBpjs = () => {
    setFormKodeKelasBpjs('');
    setFormKodeRuangBpjs('');
    setFormTypeTrxBpjs('INPUT');
    setShowDeleteBpjsModal(true);
  };

  // Buka Modal Delete Kamar BPJS
  const handleOpenDeleteBpjs = (item) => {
    setFormKodeKelasBpjs(item.kodekelas || '');
    setFormKodeRuangBpjs(item.koderuang || '');
    setFormTypeTrxBpjs('HAPUS');
    setShowDeleteBpjsModal(true);
  };

  // Hapus Data Kamar BPJS Aplicares dari Backend
  const handleDeleteKamarBpjs = async (e) => {
    e.preventDefault();
    if (!window.confirm(`Apakah Anda yakin ingin memproses transaksi BPJS ini (${formTypeTrxBpjs}) untuk Kelas ${formKodeKelasBpjs} Ruang ${formKodeRuangBpjs}?`)) {
      return;
    }
    if (!formKodeKelasBpjs || !formKodeRuangBpjs) {
      alert("Kode Kelas dan Kode Ruang harus diisi!");
      return;
    }

    setIsDeletingBpjs(true);
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/delete_kamarbpjs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          kodekelas: formKodeKelasBpjs,
          koderuang: formKodeRuangBpjs,
          typetrx: formTypeTrxBpjs
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      alert(`Transaksi BPJS Aplicares (${formTypeTrxBpjs}) berhasil diproses!`);
      setFormKodeKelasBpjs('');
      setFormKodeRuangBpjs('');
      setFormTypeTrxBpjs('HAPUS');
      setShowDeleteBpjsModal(false);
    } catch (err) {
      console.error("Gagal memproses transaksi kamar BPJS:", err);
      alert(`Gagal memproses transaksi kamar BPJS Aplicares: ${err.message}`);
    } finally {
      setIsDeletingBpjs(false);
    }
  };

  // Pagination Data Kelas RS
  const indexOfLastItemKelasRs = currentPageKelasRs * itemsPerPage;
  const indexOfFirstItemKelasRs = indexOfLastItemKelasRs - itemsPerPage;
  const currentItemsKelasRs = kelasRsList.slice(indexOfFirstItemKelasRs, indexOfLastItemKelasRs);
  const totalPagesKelasRs = Math.ceil(kelasRsList.length / itemsPerPage);

  // Filter & Pagination Data Tarif Kamar Rawat
  const filteredTarifKamar = tarifKamarList.filter(item => {
    const q = (searchTarifKamar || '').toLowerCase();
    return (
      (item.nm_kelas && item.nm_kelas.toLowerCase().includes(q)) ||
      (item.kd_kelas && item.kd_kelas.toLowerCase().includes(q)) ||
      (item.nm_klasifikasi && item.nm_klasifikasi.toLowerCase().includes(q)) ||
      (item.kd_klasifikasi && item.kd_klasifikasi.toLowerCase().includes(q)) ||
      (item.sts_paket && item.sts_paket.toLowerCase().includes(q)) ||
      (item.nm_subdivisi && item.nm_subdivisi.toLowerCase().includes(q)) ||
      (item.kd_subdivisi && item.kd_subdivisi.toLowerCase().includes(q))
    );
  });

  const indexOfLastItemTarifKamar = currentPageTarifKamar * itemsPerPageTarifKamar;
  const indexOfFirstItemTarifKamar = indexOfLastItemTarifKamar - itemsPerPageTarifKamar;
  const currentItemsTarifKamar = filteredTarifKamar.slice(indexOfFirstItemTarifKamar, indexOfLastItemTarifKamar);
  const totalPagesTarifKamar = Math.ceil(filteredTarifKamar.length / itemsPerPageTarifKamar) || 1;

  const formatRupiah = (val) => {
    if (val === null || val === undefined || isNaN(val)) return 'Rp 0';
    return 'Rp ' + Number(val).toLocaleString('id-ID');
  };


  return (
    <div style={styles.appContainer}>
      <style>{`
        .table-compact td, .table-compact th {
          padding: 0.1rem 0.2rem !important;
          vertical-align: middle;
          font-size: 0.72rem !important;
        }
        .table-compact .badge {
          padding: 0.2rem 0.35rem !important;
        }
        /* Fix for React-Bootstrap Tabs Flex Layout */
        .custom-tabs + .tab-content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane {
          flex-grow: 1;
          display: flex !important;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane > .card {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane:not(.active) {
          display: none !important;
        }
        /* Shrink Tab Titles and ensure scroll container can shrink */
        .custom-tabs .nav-link {
          font-size: 0.75rem !important;
          padding: 0.3rem 0.6rem !important;
        }
        .custom-scrollbar {
          min-height: 0 !important;
        }
      `}</style>

      {/* ══════════════ NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-shield-plus text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Finance</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>

          <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
            </div>
            
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill text-teal"></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* ══════════════ CORE MAIN CONTENT ══════════════ */}
      <div style={styles.mainContent} className="d-flex flex-column">


        {/* Notifikasi Sistem (Floating / Toast Style) */}
        {systemAlert && (
          <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999, minWidth: '300px', animation: 'fadeIn 0.3s' }}>
            <Alert variant={systemAlert.variant} className="py-3 px-4 shadow-lg border-0 d-flex align-items-center gap-3" onClose={() => setSystemAlert(null)} dismissible style={{ borderLeft: `5px solid ${systemAlert.variant === 'success' ? '#198754' : '#dc3545'}`, borderRadius: '8px' }}>
              <i className={`bi ${systemAlert.variant === 'success' ? 'bi-check-circle-fill text-success' : 'bi-exclamation-triangle-fill text-danger'} fs-4`}></i>
              <div>
                <strong className="d-block">{systemAlert.variant === 'success' ? 'Sukses!' : 'Oops!'}</strong>
                <span style={{ fontSize: '0.85rem' }}>{systemAlert.message}</span>
              </div>
            </Alert>
          </div>
        )}

        <Row className="g-2 flex-grow-1" style={{ overflow: 'hidden' }}>
          
          {/* KOLOM UTAMA: TABEL DATA KAMAR DARI BACKEND */}
          <Col lg={12} className="h-100 d-flex flex-column" style={{ minHeight: 0 }}>
            <style>
              {`
                /* Custom Scrollbar */
                .custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                .table-sm td, .table-sm th { padding: 0.2rem 0.4rem !important; }
              `}
            </style>
            
            <Tabs defaultActiveKey="master" id="kamar-tabs" className="mb-2 fw-semibold">
              <Tab eventKey="master" title={<span><i className="bi bi-server me-2"></i>Master Data Kamar SIMRS</span>}>
                <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
                  <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <span className="fw-bold"><i className="bi bi-table me-1 text-warning"></i> Tabel Kamar Internal</span>
                <div className="d-flex gap-2 align-items-center">
                  <Button variant="teal" size="sm" onClick={() => { handleClearForm(); setShowFormModal(true); }} className="d-flex align-items-center gap-1.5 fw-bold px-3 py-1.5" style={{ fontSize: '0.73rem', background: '#0d9488', border: 'none' }}>
                    <i className="bi bi-plus-circle-fill"></i> Buat Kamar Baru
                  </Button>
                  <Button variant="outline-light" size="sm" onClick={fetchKamar} disabled={isLoading} style={{ fontSize: '0.7rem' }}>
                    {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                  </Button>
                </div>
              </div>

                <Card.Body className="p-2 d-flex flex-column h-100" style={{ overflow: 'hidden' }}>
                  {/* Pencarian dan Filter */}
                  <Row className="g-2 mb-2 align-items-center flex-shrink-0">
                   <Col md={4}>
                     <InputGroup size="sm">
                       <InputGroup.Text className="bg-light text-muted border-slate"><i className="bi bi-search"></i></InputGroup.Text>
                       <Form.Control
                         type="text"
                         placeholder="Cari Kamar, Kelas, Gedung..."
                         value={searchQuery}
                         onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                         style={{ fontSize: '0.78rem' }}
                       />
                     </InputGroup>
                   </Col>

                   {/* Filter Kelas */}
                   <Col md={3}>
                     <Form.Select 
                       size="sm" 
                       value={selectedKelasFilter} 
                       onChange={(e) => { setSelectedKelasFilter(e.target.value); setCurrentPage(1); }}
                       style={{ fontSize: '0.78rem' }}
                     >
                       <option value="">Semua Kelas</option>
                       {uniqueKelas.map((k, i) => <option key={i} value={k}>{k}</option>)}
                     </Form.Select>
                   </Col>

                   {/* Filter Gedung */}
                   <Col md={3}>
                     <Form.Select 
                       size="sm" 
                       value={selectedGedungFilter} 
                       onChange={(e) => { setSelectedGedungFilter(e.target.value); setCurrentPage(1); }}
                       style={{ fontSize: '0.78rem' }}
                     >
                       <option value="">Semua Gedung</option>
                       {uniqueGedung.map((g, i) => <option key={i} value={g}>{g}</option>)}
                     </Form.Select>
                   </Col>

                   {/* Limitasi Baris per Page */}
                   <Col md={2}>
                     <Form.Select 
                       size="sm" 
                       value={itemsPerPage} 
                       onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                       style={{ fontSize: '0.78rem' }}
                     >
                       <option value={5}>5 Baris</option>
                       <option value={10}>10 Baris</option>
                       <option value={20}>20 Baris</option>
                       <option value={50}>50 Baris</option>
                       <option value={100}>100 Baris</option>
                     </Form.Select>
                   </Col>
                 </Row>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-center mb-2 flex-shrink-0">
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                      <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                      <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                  </div>

                {/* Table Area */}
                {fetchError && (
                  <div className="alert alert-warning py-1.5 px-3 mb-2.5" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                  </div>
                )}

                <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact" style={{ fontSize: '0.75rem' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '90px' }}>Kode Kamar</th>
                        <th>Nama Kamar</th>
                        <th className="d-none d-md-table-cell">Gedung & Lantai</th>
                        <th className="d-none d-md-table-cell">Divisi</th>
                        <th className="d-none d-md-table-cell">Kelas</th>
                        <th style={{ width: '90px' }} className="text-center">Kapasitas</th>
                        <th className="d-none d-md-table-cell">SatuSehat ID</th>
                        <th style={{ width: '100px' }} className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="8" className="text-center py-5 text-muted">
                            <Spinner animation="border" variant="teal" className="mb-2" />
                            <div>Memuat data kamar dari server...</div>
                          </td>
                        </tr>
                      ) : currentItems.length > 0 ? (
                        currentItems.map((item, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold text-dark-blue">{item.kd_kamar}</td>
                            <td className="fw-bold">{item.nm_kamar}</td>
                            <td className="d-none d-md-table-cell">
                              <div>{item.nm_gedung} <span className="text-muted" style={{ fontSize: '0.7rem' }}>(kd: {item.kd_gedung})</span></div>
                              <div className="text-muted" style={{ fontSize: '0.7rem' }}>Lantai: {item.nm_lantai}</div>
                            </td>
                            <td className="d-none d-md-table-cell">
                              <div className="fw-semibold text-dark">{item.nm_divisi || '-'}</div>
                              <div className="text-muted" style={{ fontSize: '0.7rem' }}>Kode: {item.kd_divisi || '-'}</div>
                            </td>
                            <td className="d-none d-md-table-cell">
                              <span 
                                className="fw-bold"
                                style={{
                                  color: (item.nm_kelas || '').toUpperCase().includes('VIP') ? '#8b5cf6' : 
                                         (item.nm_kelas || '').toUpperCase().includes('1') ? '#0284c7' : 
                                         (item.nm_kelas || '').toUpperCase().includes('2') ? '#16a34a' : 
                                         (item.nm_kelas || '').toUpperCase().includes('3') ? '#6c757d' : 
                                         '#0d9488'
                                }}
                              >
                                {item.nm_kelas || 'Tanpa Kelas'}
                              </span>
                            </td>
                            <td className="text-center fw-bold fs-6 text-dark-blue">{item.kapasitas} Bed</td>
                            <td className="d-none d-md-table-cell">
                              {item.satusehat_id ? (
                                <span className="font-monospace text-muted" style={{ fontSize: '0.7rem' }}>{item.satusehat_id}</span>
                              ) : (
                                <span className="text-muted fst-italic" style={{ fontSize: '0.7rem' }}>Belum Tertaut</span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-1">
                                <Button size="sm" variant="outline-primary" onClick={() => handleSelectEdit(item)} style={styles.actionBtn}>
                                  <i className="bi bi-pencil-fill"></i>
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item.kd_kamar)} style={styles.actionBtn}>
                                  <i className="bi bi-trash-fill"></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-4 text-muted">
                            Tidak ada data kamar yang cocok.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Footer stats summary */}
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top text-muted small" style={{ fontSize: '0.72rem' }}>
                  <span>
                    Menampilkan <strong>{filteredKamar.length > 0 ? indexOfFirstItem + 1 : 0} - {Math.min(indexOfLastItem, filteredKamar.length)}</strong> dari <strong>{filteredKamar.length}</strong> data kamar (Total: {kamarList.length})
                  </span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
              </Card.Body>
            </Card>
            </Tab>

            <Tab eventKey="aplicares" title={<span><i className="bi bi-shield-check me-2"></i>Kamar Aplicares BPJS</span>}>
              <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
                <div style={styles.cardHeader} className="bg-primary d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span className="fw-bold text-white"><i className="bi bi-cloud-check-fill me-1 text-warning"></i> Data Kamar Aplicares BPJS</span>
                  <div className="d-flex gap-2">
                    <Button variant="light" size="sm" onClick={handleOpenCreateBpjs} className="fw-bold text-primary" style={{ fontSize: '0.7rem' }}>
                      <i className="bi bi-plus-circle-fill me-1"></i> Input Ruangan Baru
                    </Button>
                    <Button variant="outline-light" size="sm" onClick={fetchKamarBpjs} disabled={isLoadingBpjs} style={{ fontSize: '0.7rem' }}>
                      {isLoadingBpjs ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload BPJS
                    </Button>
                  </div>
                </div>
                <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                  <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                    <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact" style={{ fontSize: '0.78rem' }}>
                      <thead className="table-primary sticky-top text-center align-middle">
                        <tr>
                          <th>No</th>
                          <th>Nama Ruang</th>
                          <th>Kelas</th>
                          <th>Kode Kelas</th>
                          <th>Kode Ruang</th>
                          <th>Kapasitas</th>
                          <th>Tersedia (Total)</th>
                          <th>Tersedia Pria</th>
                          <th>Tersedia Wanita</th>
                          <th>Tersedia Pria/Wanita</th>
                          <th>Status Update</th>
                          <th>Terakhir Update</th>
                          <th style={{ width: '90px' }}>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingBpjs ? (
                          <tr><td colSpan="13" className="text-center py-4 text-primary"><Spinner animation="border" size="sm" /> Memuat data Aplicares BPJS...</td></tr>
                        ) : kamarBpjsList.length > 0 ? (
                          kamarBpjsList.map((item, idx) => (
                            <tr key={idx} className="text-center">
                              <td>{item.rownumber || idx + 1}</td>
                              <td className="text-start fw-semibold">{item.namaruang || '-'}</td>
                              <td>{item.namakelas || '-'}</td>
                              <td><Badge bg="secondary">{item.kodekelas}</Badge></td>
                              <td className="fw-bold">{item.koderuang}</td>
                              <td className="fw-bold text-primary">{item.kapasitas}</td>
                              <td className="fw-bold text-success">{item.tersedia}</td>
                              <td>{item.tersediapria}</td>
                              <td>{item.tersediawanita}</td>
                              <td>{item.tersediapriawanita}</td>
                              <td>
                                <Badge bg={item.stat === 'Sudah' ? 'success' : 'warning'} text={item.stat === 'Sudah' ? 'light' : 'dark'}>
                                  {item.stat}
                                </Badge>
                              </td>
                              <td className="text-muted" style={{ fontSize: '0.7rem' }}>{item.lastupdate || '-'}</td>
                              <td className="text-center">
                                <div className="d-flex justify-content-center gap-1">
                                  <Button size="sm" variant="outline-primary" onClick={() => handleOpenUpdateBpjs(item)} style={styles.actionBtn} title="Update Kamar BPJS">
                                    <i className="bi bi-pencil-fill"></i>
                                  </Button>
                                  <Button size="sm" variant="outline-danger" onClick={() => handleOpenDeleteBpjs(item)} style={styles.actionBtn} title="Hapus Kamar BPJS">
                                    <i className="bi bi-trash-fill"></i>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="13" className="text-center text-muted py-4">Tidak ada data kamar terdaftar di Aplicares BPJS.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Tab>

            <Tab eventKey="refkelas" title={<span><i className="bi bi-list-task me-2"></i>Referensi Kelas BPJS</span>}>
              <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
                <div style={styles.cardHeader} className="bg-success d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span className="fw-bold text-white"><i className="bi bi-file-earmark-medical-fill me-1 text-warning"></i> Data Referensi Kelas BPJS</span>
                  <Button variant="outline-light" size="sm" onClick={fetchRefKelasBpjs} disabled={isLoadingRefKelas} style={{ fontSize: '0.7rem' }}>
                    {isLoadingRefKelas ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload BPJS
                  </Button>
                </div>
                <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                  <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                    <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact" style={{ fontSize: '0.78rem' }}>
                      <thead className="table-success sticky-top text-center align-middle">
                        <tr>
                          <th style={{ width: '80px' }}>No</th>
                          <th style={{ width: '150px' }}>Kode Kelas</th>
                          <th>Nama Kelas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingRefKelas ? (
                          <tr><td colSpan="3" className="text-center py-4 text-success"><Spinner animation="border" size="sm" /> Memuat data Referensi Kelas BPJS...</td></tr>
                        ) : refKelasBpjsList.length > 0 ? (
                          refKelasBpjsList.map((item, idx) => (
                            <tr key={idx} className="text-center">
                              <td>{idx + 1}</td>
                              <td><Badge bg="secondary" style={{ fontSize: '0.75rem', padding: '0.35em 0.65em' }}>{item.kodekelas}</Badge></td>
                              <td className="text-start fw-semibold">{item.namakelas || '-'}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="3" className="text-center text-muted py-4">Tidak ada data referensi kelas BPJS.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Tab>

            <Tab eventKey="kelasrs" title={<span><i className="bi bi-building-fill-add me-2"></i>Data Kelas RS</span>}>
              <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
                <div style={styles.cardHeader} className="bg-info d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span className="fw-bold text-dark"><i className="bi bi-hospital-fill me-1 text-warning"></i> Referensi Data Kelas Rumah Sakit</span>
                  <Button variant="outline-dark" size="sm" onClick={fetchKelasRs} disabled={isLoadingKelasRs} style={{ fontSize: '0.7rem' }}>
                    {isLoadingKelasRs ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload Data
                  </Button>
                </div>
                <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                  {/* Pagination Controls Data Kelas RS */}
                  <div className="d-flex justify-content-center mb-2 flex-shrink-0">
                      <Pagination size="sm" className="mb-0">
                        <Pagination.First onClick={() => setCurrentPageKelasRs(1)} disabled={currentPageKelasRs === 1} />
                        <Pagination.Prev onClick={() => setCurrentPageKelasRs(prev => Math.max(prev - 1, 1))} disabled={currentPageKelasRs === 1} />
                        {[...Array(totalPagesKelasRs)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPageKelasRs}
                            onClick={() => setCurrentPageKelasRs(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => setCurrentPageKelasRs(prev => Math.min(prev + 1, totalPagesKelasRs))} disabled={currentPageKelasRs === totalPagesKelasRs || totalPagesKelasRs === 0} />
                        <Pagination.Last onClick={() => setCurrentPageKelasRs(totalPagesKelasRs)} disabled={currentPageKelasRs === totalPagesKelasRs || totalPagesKelasRs === 0} />
                      </Pagination>
                  </div>

                  <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                    <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact" style={{ fontSize: '0.75rem' }}>
                      <thead className="table-info sticky-top text-center align-middle text-dark">
                        <tr>
                          <th style={{ width: '60px' }}>No</th>
                          <th>Kode Kelas</th>
                          <th>Nama Kelas</th>
                          <th>ID BPJS</th>
                          <th>Nama Sitegar</th>
                          <th>Posisi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingKelasRs ? (
                          <tr><td colSpan="6" className="text-center py-4 text-info"><Spinner animation="border" size="sm" /> Memuat data Kelas RS...</td></tr>
                        ) : currentItemsKelasRs.length > 0 ? (
                          currentItemsKelasRs.map((item, idx) => (
                            <tr key={idx} className="text-center">
                              <td>{indexOfFirstItemKelasRs + idx + 1}</td>
                              <td className="fw-bold">{item.kd_klas}</td>
                              <td className="text-start fw-semibold">{item.nm_klas || '-'}</td>
                              <td><Badge bg={item.idbpjs ? 'primary' : 'secondary'} style={{ fontSize: '0.7rem' }}>{item.idbpjs || '-'}</Badge></td>
                              <td>{item.nm_sitegar || '-'}</td>
                              <td className="fw-bold" style={{ color: item.posisi === 'RI' ? '#0d9488' : item.posisi === 'RJ' ? '#d97706' : '#64748b' }}>
                                {item.posisi === 'RI' ? 'Rawat Inap' : item.posisi === 'RJ' ? 'Rawat Jalan' : item.posisi || '-'}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="6" className="text-center text-muted py-4">Tidak ada data Kelas RS.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Tab>

            <Tab eventKey="tarifkamar" title={<span><i className="bi bi-cash-stack me-2"></i>Tarif Kamar Rawat</span>}>
              <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
                <div style={styles.cardHeader} className="bg-dark text-white d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span className="fw-bold"><i className="bi bi-tag-fill me-1 text-warning"></i> Data Tarif Kamar Rawat Inap</span>
                  <Button variant="outline-light" size="sm" onClick={fetchTarifKamar} disabled={isLoadingTarifKamar} style={{ fontSize: '0.7rem' }}>
                    {isLoadingTarifKamar ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload Tarif
                  </Button>
                </div>
                <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                  {/* Filter Klasifikasi, Pencarian dan Pagination Controls */}
                  <Row className="g-2 mb-2 align-items-center flex-shrink-0">
                    {/* Filter Dropdown kd_klasifikasi */}
                    <Col lg={4} md={6}>
                      <Form.Group className="d-flex align-items-center gap-2">
                        <Form.Label className="mb-0 fw-bold text-dark" style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                          <i className="bi bi-filter-circle-fill text-primary me-1"></i>Klasifikasi:
                        </Form.Label>
                        <Form.Select
                          size="sm"
                          value={selectedKdKlasifikasi}
                          onChange={(e) => {
                            const newKd = e.target.value;
                            setSelectedKdKlasifikasi(newKd);
                            setCurrentPageTarifKamar(1);
                            fetchTarifKamar(newKd);
                          }}
                          disabled={isLoadingKlasifikasi || isLoadingTarifKamar}
                          style={{ fontSize: '0.78rem', fontWeight: 600 }}
                        >
                          <option value="">-- Semua Klasifikasi Tarif --</option>
                          {klasifikasiList.map((k, idx) => {
                            const kd = k.kd_klas || k.kd_klasifikasi || k.kode || k.kd_penjamin;
                            const nm = k.nm_klas || k.nm_klasifikasi || k.nama || k.klasifikasi;
                            return (
                              <option key={idx} value={kd}>
                                {kd} — {nm}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {selectedKdKlasifikasi && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            title="Reset filter klasifikasi"
                            onClick={() => {
                              setSelectedKdKlasifikasi('');
                              setCurrentPageTarifKamar(1);
                              fetchTarifKamar('');
                            }}
                            style={{ padding: '0.15rem 0.45rem', fontSize: '0.72rem' }}
                          >
                            ✕
                          </Button>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Input Pencarian */}
                    <Col lg={4} md={6}>
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-light text-muted border-slate"><i className="bi bi-search"></i></InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Cari Kelas, Subdivisi, Status, Klasifikasi..."
                          value={searchTarifKamar}
                          onChange={(e) => { setSearchTarifKamar(e.target.value); setCurrentPageTarifKamar(1); }}
                          style={{ fontSize: '0.78rem' }}
                        />
                        {searchTarifKamar && (
                          <Button variant="outline-secondary" size="sm" onClick={() => setSearchTarifKamar('')}>
                            ✕
                          </Button>
                        )}
                      </InputGroup>
                    </Col>

                    {/* Page Size & Pagination */}
                    <Col lg={4} md={12} className="d-flex justify-content-lg-end justify-content-between align-items-center gap-2">
                      <Form.Select 
                        size="sm" 
                        value={itemsPerPageTarifKamar} 
                        onChange={(e) => { setItemsPerPageTarifKamar(Number(e.target.value)); setCurrentPageTarifKamar(1); }}
                        style={{ fontSize: '0.78rem', width: '90px' }}
                      >
                        <option value={5}>5 Baris</option>
                        <option value={10}>10 Baris</option>
                        <option value={20}>20 Baris</option>
                        <option value={50}>50 Baris</option>
                      </Form.Select>

                      <Pagination size="sm" className="mb-0">
                        <Pagination.First onClick={() => setCurrentPageTarifKamar(1)} disabled={currentPageTarifKamar === 1} />
                        <Pagination.Prev onClick={() => setCurrentPageTarifKamar(prev => Math.max(prev - 1, 1))} disabled={currentPageTarifKamar === 1} />
                        {[...Array(totalPagesTarifKamar)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPageTarifKamar}
                            onClick={() => setCurrentPageTarifKamar(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => setCurrentPageTarifKamar(prev => Math.min(prev + 1, totalPagesTarifKamar))} disabled={currentPageTarifKamar === totalPagesTarifKamar || totalPagesTarifKamar === 0} />
                        <Pagination.Last onClick={() => setCurrentPageTarifKamar(totalPagesTarifKamar)} disabled={currentPageTarifKamar === totalPagesTarifKamar || totalPagesTarifKamar === 0} />
                      </Pagination>
                    </Col>
                  </Row>

                  <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                    <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact" style={{ fontSize: '0.75rem' }}>
                      <thead className="table-dark sticky-top text-center align-middle">
                        <tr>
                          <th style={{ width: '45px' }}>No</th>
                          <th style={{ width: '85px' }}>Kode Kelas</th>
                          <th>Nama Kelas</th>
                          <th>Klasifikasi</th>
                          <th>Status Paket</th>
                          <th className="text-end">Tarif Kamar</th>
                          <th className="text-end">Tarif Paket</th>
                          <th className="text-end">Paramedis</th>
                          <th className="text-end">Komisi Rujuk</th>
                          <th>Subdivisi</th>
                          <th>Selisih</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingTarifKamar ? (
                          <tr><td colSpan="11" className="text-center py-4 text-primary"><Spinner animation="border" size="sm" /> Memuat data Tarif Kamar Rawat...</td></tr>
                        ) : currentItemsTarifKamar.length > 0 ? (
                          currentItemsTarifKamar.map((item, idx) => (
                            <tr key={idx}>
                              <td className="text-center">{indexOfFirstItemTarifKamar + idx + 1}</td>
                              <td className="text-center fw-bold"><Badge bg="secondary">{item.kd_kelas}</Badge></td>
                              <td className="fw-semibold text-dark">{item.nm_kelas || '-'}</td>
                              <td>
                                {item.nm_klasifikasi ? (
                                  <Badge bg="info" text="dark" style={{ fontSize: '0.68rem', fontWeight: 600 }}>
                                    {item.kd_klasifikasi ? `${item.kd_klasifikasi} - ` : ''}{item.nm_klasifikasi}
                                  </Badge>
                                ) : item.kd_klasifikasi ? (
                                  <Badge bg="secondary" style={{ fontSize: '0.68rem' }}>{item.kd_klasifikasi}</Badge>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td className="text-center">
                                <Badge bg={item.sts_paket === 'Normal' ? 'primary' : 'info'}>
                                  {item.sts_paket || '-'}
                                </Badge>
                              </td>
                              <td className="text-end fw-bold text-success">{formatRupiah(item.tarif)}</td>
                              <td className="text-end text-muted">{formatRupiah(item.tarifpaket)}</td>
                              <td className="text-end text-primary">{formatRupiah(item.paramedis)}</td>
                              <td className="text-end text-muted">{formatRupiah(item.komisirujuk)}</td>
                              <td>
                                <div>{item.nm_subdivisi || '-'}</div>
                                {item.kd_subdivisi && <span className="text-muted" style={{ fontSize: '0.7rem' }}>Kode: {item.kd_subdivisi}</span>}
                              </td>
                              <td className="text-center">
                                <Badge bg="light" text="dark" className="border">
                                  {item.selisih || '-'}
                                </Badge>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="11" className="text-center text-muted py-4">Tidak ada data Tarif Kamar Rawat{selectedKdKlasifikasi ? ` untuk klasifikasi ${selectedKdKlasifikasi}` : ''}.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Footer Stats Summary */}
                  <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top text-muted small" style={{ fontSize: '0.72rem' }}>
                    <span>
                      Menampilkan <strong>{filteredTarifKamar.length > 0 ? indexOfFirstItemTarifKamar + 1 : 0} - {Math.min(indexOfLastItemTarifKamar, filteredTarifKamar.length)}</strong> dari <strong>{filteredTarifKamar.length}</strong> data tarif (Total: {tarifKamarList.length})
                      {selectedKdKlasifikasi && (
                        <span className="ms-2 badge bg-primary">
                          Filter: {selectedKdKlasifikasi}
                        </span>
                      )}
                    </span>
                    <span>Endpoint: <strong>/show_tarifkamar</strong></span>
                  </div>
                </Card.Body>
              </Card>
            </Tab>
          </Tabs>
          </Col>
        </Row>

        {/* ── Summary Stats Cards (Footer Rangkuman) ── */}
        <Row className="g-2 mt-1 flex-shrink-0 justify-content-center">
          <Col md={2} sm={4}>
            <div style={{ background: '#f0fdfa', border: '1.5px solid #0d948822', borderRadius: '10px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }} className="shadow-sm h-100">
              <div style={{ background: '#0d9488', borderRadius: '8px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-hospital-fill text-white fs-6"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '0.9rem', color: '#0d9488', lineHeight: 1.1 }}>
                  {kamarList.length} <span style={{ fontSize: '0.65rem', fontWeight: 600 }}>Kamar</span>
                </div>
                <div className="text-muted fw-semibold" style={{ fontSize: '0.6rem' }}>
                  Total Kapasitas: <strong>{grandTotalBeds} Bed</strong>
                </div>
              </div>
            </div>
          </Col>

          {/* Rangkuman Per Kelas Dynamis */}
          {classSummary.map((item, idx) => {
            const colors = [
              { color: '#8b5cf6', bg: '#f5f3ff', icon: 'bi-star-fill' },
              { color: '#0284c7', bg: '#eff6ff', icon: 'bi-door-open-fill' },
              { color: '#16a34a', bg: '#f0fdf4', icon: 'bi-building-fill-check' },
              { color: '#d97706', bg: '#fffbeb', icon: 'bi-tags-fill' }
            ];
            const theme = colors[idx % colors.length];

            return (
              <Col md={2} sm={4} key={idx}>
                <div style={{ background: theme.bg, border: `1.5px solid ${theme.color}22`, borderRadius: '10px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }} className="shadow-sm">
                  <div style={{ background: theme.color, borderRadius: '8px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <i className={`bi ${theme.icon} text-white fs-6`}></i>
                  </div>
                  <div>
                    <div className="fw-bold text-dark" style={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                      {item.kelas}
                    </div>
                    <div className="fw-semibold" style={{ fontSize: '0.65rem', color: theme.color }}>
                      <strong>{item.totalKamar}</strong> Kamar | <strong>{item.totalBed}</strong> Bed
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>


      </div>

      {/* ══════════════ MODAL FORM ENTRI/EDIT DATA KAMAR ══════════════ */}
      <Modal show={showFormModal} onHide={handleClearForm} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#ffffff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square text-warning fs-5"></i>
            <span>{isEditing ? `Edit Data Kamar: ${formNamaKamar}` : 'Buat Data Kamar Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSubmit}>
            {/* Kode Kamar */}
            <Form.Group className="mb-2.5">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Kamar (kd_kamar)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Contoh: 002"
                value={formKodeKamar}
                onChange={(e) => setFormKodeKamar(e.target.value)}
                disabled={isEditing}
                required
                style={styles.formControl}
              />
            </Form.Group>

            {/* Nama Kamar */}
            <Form.Group className="mb-2.5">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Kamar (nm_kamar)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Contoh: 2001 / UGD"
                value={formNamaKamar}
                onChange={(e) => setFormNamaKamar(e.target.value)}
                required
                style={styles.formControl}
              />
            </Form.Group>

            <Row className="g-2 mb-2.5">
              {/* Pilihan Divisi */}
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Divisi Ruangan</Form.Label>
                  <Form.Select
                    value={formKodeDivisi}
                    onChange={(e) => {
                      const selectedKd = e.target.value;
                      setFormKodeDivisi(selectedKd);
                      const selectedDiv = divisiOptions.find(d => d.kd_divisi === selectedKd);
                      setFormNamaDivisi(selectedDiv ? selectedDiv.nm_divisi : '-');
                    }}
                    style={styles.formControl}
                  >
                    <option value="-">-- Pilih Divisi --</option>
                    {divisiOptions.map((div, i) => (
                      <option key={i} value={div.kd_divisi}>{div.kd_divisi} - {div.nm_divisi}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-2.5">
              {/* Kelas Kamar */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kelas Kamar</Form.Label>
                  <Form.Select 
                    value={formKelas} 
                    onChange={(e) => setFormKelas(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Kelas 1">Kelas 1</option>
                    <option value="Kelas 2">Kelas 2</option>
                    <option value="Kelas 3">Kelas 3</option>
                    <option value="Kelas VIP">Kelas VIP</option>
                    <option value="Kelas ICU">Kelas ICU</option>
                    <option value="Kelas Isolasi">Kelas Isolasi</option>
                    <option value="Poliklinik dan UGD">Poliklinik dan UGD</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Kapasitas Bed */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kapasitas (Bed)</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    value={formKapasitas}
                    onChange={(e) => setFormKapasitas(e.target.value)}
                    required
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-2.5">
              {/* Gedung */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Gedung</Form.Label>
                  <Form.Select 
                    value={formGedung} 
                    onChange={(e) => setFormGedung(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Gedung B">Gedung B (kd: 02)</option>
                    <option value="Gedung A">Gedung A (kd: 01)</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Lantai */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Lantai</Form.Label>
                  <Form.Select 
                    value={formLantai} 
                    onChange={(e) => setFormLantai(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Satu">Satu (kd: 01)</option>
                    <option value="Dua">Dua (kd: 02)</option>
                    <option value="Tiga">Tiga (kd: 03)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* SatuSehat ID */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>SatuSehat ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Masukkan UUID SatuSehat"
                value={formSatuSehatId}
                onChange={(e) => setFormSatuSehatId(e.target.value)}
                style={styles.formControl}
              />
            </Form.Group>

            {/* Button Actions */}
            <div className="d-flex justify-content-end gap-2 border-top pt-2.5">
              <Button type="button" variant="secondary" size="sm" onClick={handleClearForm}>
                Batal
              </Button>
              <Button type="submit" variant="teal" size="sm" className="fw-bold" style={styles.btnSave}>
                <i className="bi bi-hdd-fill me-1"></i> Simpan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ══════════════ MODAL TRANSAKSI KAMAR BPJS APLICARES ══════════════ */}
      <Modal show={showDeleteBpjsModal} onHide={() => setShowDeleteBpjsModal(false)} centered backdrop="static">
        <Modal.Header closeButton style={{ background: formTypeTrxBpjs === 'INPUT' ? 'linear-gradient(135deg, #0d9488 0%, #10b981 100%)' : 'linear-gradient(135deg, #7f1d1d 0%, #dc2626 100%)', color: '#ffffff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className={formTypeTrxBpjs === 'INPUT' ? 'bi bi-plus-circle-fill text-warning fs-5' : 'bi bi-trash3-fill text-warning fs-5'}></i>
            <span>{formTypeTrxBpjs === 'INPUT' ? 'Kirim Kamar Baru ke BPJS Aplicares' : 'Hapus Kamar BPJS Aplicares'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleDeleteKamarBpjs}>
            
            {/* Kode Kelas */}
            <Form.Group className="mb-2.5">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Kelas BPJS (kodekelas)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Contoh: KLS1 / VIP"
                value={formKodeKelasBpjs}
                onChange={(e) => setFormKodeKelasBpjs(e.target.value)}
                required
                style={styles.formControl}
              />
            </Form.Group>

            {/* Kode Ruang */}
            <Form.Group className="mb-2.5">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Ruang Kamar (koderuang)</Form.Label>
              {formTypeTrxBpjs === 'INPUT' ? (
                <Form.Select
                  value={formKodeRuangBpjs}
                  onChange={(e) => setFormKodeRuangBpjs(e.target.value)}
                  required
                  style={styles.formSelect}
                >
                  <option value="">-- Pilih Ruang Kamar --</option>
                  {kamarList.map((k, i) => (
                    <option key={i} value={k.kd_kamar}>{k.kd_kamar} - {k.nm_kamar}</option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control
                  type="text"
                  value={formKodeRuangBpjs}
                  onChange={(e) => setFormKodeRuangBpjs(e.target.value)}
                  disabled={formTypeTrxBpjs === 'HAPUS'}
                  required
                  style={styles.formControl}
                />
              )}
            </Form.Group>

            {/* Jenis Transaksi (typetrx) */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Jenis Transaksi BPJS (typetrx)</Form.Label>
              <Form.Select
                value={formTypeTrxBpjs}
                onChange={(e) => setFormTypeTrxBpjs(e.target.value)}
                style={styles.formSelect}
              >
                <option value="HAPUS">HAPUS (Hapus Data)</option>
                <option value="INPUT">INPUT (Tambah Data)</option>
              </Form.Select>
            </Form.Group>

            {/* Actions */}
            <div className="d-flex justify-content-end gap-2 border-top pt-2.5">
              <Button type="button" variant="secondary" size="sm" onClick={() => setShowDeleteBpjsModal(false)} disabled={isDeletingBpjs}>
                Batal
              </Button>
              <Button type="submit" variant={formTypeTrxBpjs === 'INPUT' ? 'teal' : 'danger'} size="sm" className="fw-bold" disabled={isDeletingBpjs} style={formTypeTrxBpjs === 'INPUT' ? styles.btnSave : {}}>
                {isDeletingBpjs ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-send-fill me-1"></i>}
                {formTypeTrxBpjs === 'INPUT' ? 'Kirim Data' : 'Hapus Data'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    height: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.2rem 0.8rem',
    flexShrink: 0,
  },
  mainContent: {
    flex: 1,
    padding: '0.2rem 0.4rem',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  mainCard: {
    borderRadius: '12px',
    border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.3rem 0.6rem',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  formControl: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  formSelect: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  btnSave: {
    background: '#0d9488',
    borderColor: '#0d9488',
    color: '#ffffff',
    fontSize: '0.78rem',
  },
  actionBtn: {
    padding: '0.2rem 0.4rem',
    fontSize: '0.7rem',
  },
  badgeStyle: {
    fontSize: '0.7rem',
    fontWeight: '600',
    padding: '4px 8px',
    borderRadius: '20px',
  }
};

export default DataKamar;
